import { VueConstructor } from 'vue';
import middleware from '@/layout/middleware.vue';
import DataView from '@/layout/data-manage/data-view.vue';
import finance from './views/finance/finance.vue';
// import benefits from './views/benefits.vue';

import { RouteConfig } from 'vue-router';
import BaseComponent from '@/component/evaluate/base/base-component.vue';
import EnergyEfficiency from '@/component/evaluate/comprehensive-benefit-analysis/energyEfficiency.vue';
// import Composition from '@/component/evaluate/composition/composition.vue';
import FinanceComponent from '@/component/evaluate/views/finance/finance-component.vue';
import ProfitComponent from '@/component/evaluate/views/finance/profit-component.vue';
import EnvironmentalProtection from './comprehensive-benefit-analysis/environmental-protection.vue';

const Composition = (): Promise<typeof import('*.vue')> => import('@/component/evaluate/composition/composition.vue');

const evaluateRouter: RouteConfig = {
    path: 'evaluate',
    name: 'evaluate',
    component: DataView,
    meta: { requireAuth: true },
    redirect: '/header/evaluate/financial_evaluation/basic_parameters/composition',
    children: [
        {
            path: 'financial_evaluation',
            component: middleware,
            name: 'financial_evaluation',
            meta: { title: '财务评价', role: ['admin', 'editor'], icon: 'listline', visible: true },
            children: [
                {
                    path: 'basic_parameters',
                    component: middleware,
                    name: 'basic_parameters',
                    meta: { title: '基础参数', role: ['admin', 'editor'], icon: 'listline', visible: true },
                    children: [
                        {
                            name: 'composition',
                            path: 'composition',
                            component: Composition,
                            meta: {
                                title: '投资组成',
                                role: ['admin', 'editor'],
                                params: {
                                    type: 'investmentbanchandproportion',
                                    params: '投资组成',
                                },
                                icon: 'energy',
                                visible: true,
                            },
                        },
                        {
                            name: 'source',
                            path: 'source',
                            component: BaseComponent,
                            meta: {
                                title: '资金来源',
                                role: ['admin', 'editor'],
                                params: {
                                    type: 'capitalsource',
                                    params: '资金来源',
                                },
                                icon: 'energy',
                                visible: true,
                            },
                        },
                        {
                            name: 'assets',
                            path: 'assets',
                            component: BaseComponent,
                            meta: {
                                title: '资产形式',
                                role: ['admin', 'editor'],
                                icon: 'energy',
                                params: {
                                    type: 'assetformation',
                                    params: '资产形式',
                                },
                                visible: true,
                            },
                        },
                        {
                            name: 'productionCost',
                            path: 'productionCost',
                            component: BaseComponent,
                            meta: {
                                title: '生产成本',
                                role: ['admin', 'editor'],
                                icon: 'energy',
                                params: { type: 'productioncost', params: '生产成本' },
                                visible: true,
                            },
                        },
                        {
                            name: 'charge',
                            path: 'charge',
                            component: BaseComponent,
                            meta: {
                                title: '流动资金及财务费用',
                                role: ['admin', 'editor'],
                                icon: 'energy',
                                params: { type: 'workingcapitalandfinancialexpenses', params: '流动资金及财务费用' },
                                visible: true,
                            },
                        },
                        {
                            path: 'tax_rate',
                            component: BaseComponent,
                            name: 'tax_rate',
                            meta: {
                                title: '税率及附加',
                                role: ['admin', 'editor'],
                                params: { type: 'projectcalculation', params: '损益参数' },
                                icon: 'energy',
                                visible: true,
                            },
                        },
                    ],
                },
                {
                    path: 'financial_evaluation_result',
                    component: middleware,
                    name: 'financial_evaluation_result',
                    meta: { title: '财务评价结果', role: ['admin', 'editor'], icon: 'listline', visible: true },
                    children: [
                        {
                            path: 'index',
                            component: finance as unknown as VueConstructor<Vue>,
                            name: 'index',
                            meta: { title: '概览', role: ['admin', 'editor'], icon: 'listline', visible: true },
                        },
                        {
                            path: 'basicForm',
                            name: 'basicForm',
                            component: middleware,
                            meta: { title: '基本报表', role: ['admin', 'editor'], icon: 'listline', visible: true },
                            children: [
                                {
                                    path: 'profit',
                                    component: FinanceComponent,
                                    name: 'profit',
                                    meta: {
                                        title: '利润与利润分配',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getEconomyResult', params: '利润与利润分配' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'cash_flow',
                                    component: ProfitComponent,
                                    name: 'cash_flow',
                                    meta: {
                                        title: '财务计划现金流量',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getFinancialPlanCashFlowResult', params: '财务计划现金流量' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'assets_liabilities',
                                    component: ProfitComponent,
                                    name: 'assets_liabilities',
                                    meta: {
                                        title: '资产负债',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getLiabilityAssetsResult', params: '资产负债' },
                                        visible: true,
                                    },
                                },
                            ],
                        },
                        {
                            path: 'assistForm',
                            name: 'assistForm',
                            component: middleware,
                            meta: { title: '辅助报表', role: ['admin', 'editor'], icon: 'listline', visible: true },
                            children: [
                                {
                                    path: 'investment_use_plan',
                                    component: ProfitComponent,
                                    name: 'investment_use_plan',
                                    meta: {
                                        title: '投资使用计划与资金筹措',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getInvestPlanDataResult', params: '投资使用计划与资金筹措' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'loan_repayment_plan',
                                    component: ProfitComponent,
                                    name: 'loan_repayment_plan',
                                    meta: {
                                        title: '借款还本付息计划',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getLoanRepaymentPlanResult', params: '借款还本付息计划' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'liquidity_estimation',
                                    component: FinanceComponent,
                                    name: 'liquidity_estimation',
                                    meta: {
                                        title: '流动资金估算',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getFlowCashEvaluteResult', params: '流动资金估算' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'asset_depreciation',
                                    component: ProfitComponent,
                                    name: 'asset_depreciation',
                                    meta: {
                                        title: '资产折旧与摊销估算',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getAssetsDepreciationResult', params: '资产折旧与摊销估算' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'total_cost_estimation',
                                    component: FinanceComponent,
                                    name: 'total_cost_estimation',
                                    meta: {
                                        title: '总成本费用估算表',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getSumCostResult', params: '总成本费用估算表' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'total_investment_cashFlow',
                                    component: ProfitComponent,
                                    name: 'total_investment_cashFlow',
                                    meta: {
                                        title: '项目总投资现金流量',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getSumInvestFlowCashResult', params: '项目总投资现金流量' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'capital_cashFlow',
                                    component: ProfitComponent,
                                    name: 'capital_cashFlow',
                                    meta: {
                                        title: '项目资本金现金流量',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getProjectCashFlowResult', params: '项目资本金现金流量' },
                                        visible: true,
                                    },
                                },
                                {
                                    path: 'additional_VAT_estimates',
                                    component: FinanceComponent,
                                    name: 'additional_VAT_estimates',
                                    meta: {
                                        title: '营业收入、税金、附加和增值税估算',
                                        role: ['admin', 'editor'],
                                        icon: 'listline',
                                        params: { type: 'getIncomeTaxResult', params: '营业收入、税金、附加和增值税估算' },
                                        visible: true,
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            path: 'environmentalProtection',
            component: EnvironmentalProtection,
            name: 'environmentalProtection',
            meta: { title: '环保评价', role: ['admin', 'editor'], icon: 'listline', visible: true },
        },
        // {
        //     path: 'benefits',
        //     component: (benefits as unknown) as VueConstructor<Vue>,
        //     name: 'benefits',
        //     meta: { title: '可靠性评价', role: ['admin', 'editor'], icon: 'listline' },
        // },
        {
            path: 'energyEfficiency',
            component: EnergyEfficiency,
            name: 'energyEfficiency',
            meta: { title: '能效评价', role: ['admin', 'editor'], icon: 'listline', visible: true },
        },
        // {
        //     path: 'evaluateTotal',
        //     component: (evaluate as unknown) as VueConstructor<Vue>,
        //     name: 'evaluateTotal',
        //     meta: { title: '整体分析', role: ['admin', 'editor'], icon: 'listline' },
        // },
    ],
};

export default evaluateRouter;
